module.exports = __webpack_public_path__ + "img/fig32.ffe2ee50.jpg";